import {Component, Inject, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import * as _ from "lodash";
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';

@AcDialog({
  width: 400,
})
@Component({
  selector: 'move-rule-dialog',
  templateUrl: './move-rule-dialog.component.html',
  styleUrls: ['./move-rule-dialog.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class MoveRuleDialogComponent implements OnInit {

  data;
  selectedGroup: any;
  groupList: any;
  ruleList: any;
  selectedRule: any;
  allRules: any;
  oldListOrder;


  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private userPrivilege: UserPrivilegeService) {
    dialogConfig.submitButtonDisabled = true;
  }

  @Input()
  openEventName: string;

  @Input()
  closeEventName: string;

  @Input()
  dialogTitle: string;

  @Input()
  labeledValue = 'name';

  filteredList: any;
  ruleId: number;


  onOk: () => void;
  canSubmit: boolean;

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized(RoleTypeEnum.ROUTING);

    const parameters: any = this.dialogConfig.dialogData.sentParameters;

    this.allRules = this.dialogConfig.dialogData.rules;
    this.groupList = this.dialogConfig.dialogData.groups;
    this.ruleId = parameters.originalRuleId;
    this.selectedRule = this.allRules.find(rule => rule.id === parameters.originalRuleId);
    this.selectedGroup = this.selectedRule.rrGroupId;
    this.getRulesOfSelectedGroup(this.selectedGroup);
    this.oldListOrder = this.ruleList.map((item) => item.id);

    this.dialogConfig.preSubmit = () => {
      this.updateParameters(parameters);

      return true;
    };
  }

  private notLast(value): boolean {
    return this.ruleList.indexOf(value) < this.ruleList.length - 1;
  }

  private notFirst(value): boolean {
    return this.ruleList.indexOf(value) > 0;
  }

  private updateParameters(parameters): void {
    const itemToMove =  this.ruleList.find((item) => {
      return item.id === this.ruleId;
    });
    const index = this.ruleList.findIndex(item => item.id === itemToMove.id);

    if (this.notFirst(itemToMove)) {
      parameters.prevId = this.ruleList[index - 1].id;
    }
    if (this.notLast(itemToMove)) {
      parameters.nextId = this.ruleList[index + 1].id;
    }
    parameters.groupId = this.selectedGroup;
  }

  getRulesOfSelectedGroup(groupId): void {
    this.ruleList = this.allRules.filter(rule => rule.rrGroupId === groupId);
    this.ruleList.sort((a, b) => {
      return a - b;
    });

    if (this.selectedRule.rrGroupId !== groupId) {
      this.ruleList.unshift(this.selectedRule);
      this.dialogConfig.submitButtonDisabled = false;
    }else {
      this.dialogConfig.submitButtonDisabled = true;
    }
  }

  onRuleListChanged(items): void {
    this.ruleList = items;
    if (this.oldListOrderHasNotChanged()){
      this.dialogConfig.submitButtonDisabled = true;
    }
    else{
      this.dialogConfig.submitButtonDisabled = false;
    }
  }

  private oldListOrderHasNotChanged(): boolean{
    const newOrderList = this.ruleList.map((item) => item.id);
    return _.isEqual(this.oldListOrder, newOrderList);
  }

}
